export default {
    failed: 'Действие не выполнено',
    success: 'Действие выполнено успешно',
    // Common
    commonInfo: 'Общая информация',
    contactInfo: 'Контактная информация',
    linkedTelegramAccount: 'Привязанный Telegram аккаунт',
    loading: 'Загрузка',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    close: 'Закрыть',
    yes: 'Да',
    no: 'Нет',
    error: 'Ошибка',
    invalidCharacters: 'Обнаружены недопустимые символы',
    required: 'Обязательное поле',
    search: 'Поиск',
    // Auth
    login: 'Логин',
    password: 'Пароль',
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
    logout: 'Выйти',
    registration: 'Регистрация',
    confirmPassword: 'Подтвердите пароль',
    email: 'Email',
    name: 'Имя',
    verificationCode: 'Код подтверждения',
    verify: 'Подтвердить',
    linkTelegramFirst: 'Пожалуйста, сначала привяжите свой Telegram аккаунт.',
    // Header
    profile: 'Профиль',
    settings: 'Настройки',
    confirmAction: 'Подтвердите действие',
    // Dashboard
    farms: 'Фермы',
    users: 'Пользователи',
    newFarm: 'Новая ферма',
    addNewFarm: 'Добавить ферму',
    farm: 'Ферма',
    noFarms: 'Фермы не найдены',
    // Farm
    farmName: 'Название фермы',
    description: 'Описание',
    token: 'Токен',
    mainSettings: 'Основные настройки',
    deleteFarm: 'Удалить ферму',
    deleteFarmConfirm: 'Удалить ферму?',
    yesDeleteFarm: 'Да, удалить ферму',
    withToken: 'с токеном',
    willBeDeleted: 'будет удалена',
    farmCreated: 'Ферма создана',
    farmUpdated: 'Ферма обновлена',
    farmDeleted: 'Ферма удалена',
    // Devices
    devices: 'Устройства',
    miners: 'Майнеры',
    servers: 'Серверы',
    apps: 'Приложения',
    online: 'Онлайн',
    offline: 'Оффлайн',
    total: 'Всего',
    noConnectedMiners: 'Нет подключённых майнеров',
    noRegisteredApps: 'Нет зарегистрированных приложений',
    user: 'Пользователь',
    dashboard: 'Панель управления',
    // Farm Page
    connect: 'Подключение',
    ipRanges: 'IP диапазоны',
    network: 'Сеть',
    advancedSettings: 'Расширенные настройки',
    tune: 'Тюнинг',
    chainManagement: 'Управление цепями',
    schedule: 'Расписание',
    server: 'Сервер',
    notSelected: 'Не выбрано',
    minerType: 'Тип майнера',
    boardType: 'Тип платы',
    selectMinerType: 'Выберите тип майнера',
    hashrate: 'Хешрейт',
    selected: 'Выбрано',
    // Commands
    start: 'Запустить',
    stop: 'Остановить',
    restart: 'Перезапустить',
    reboot: 'Перезагрузить',
    revertStock: 'Сбросить прошивку',
    factoryDefault: 'Заводские настройки',
    blink: 'Мигание',
    minerSettings: 'Настройки майнера',
    changePassword: 'Изменить пароль',
    poolsInfo: 'Информация о пулах',
    serialNumber: 'Серийный номер',
    cloud: 'Облако',
    scanNetwork: 'Сканировать сеть',
    updateFirmware: 'Обновить прошивку',
    // Dialogs
    noMinersSelected: 'Майнеры не выбраны',
    selectOneMiner: 'Выберите один майнер',
    confirmYourAction: 'Подтвердите действие',
    confirm: 'Подтвердить',
    actionCompleted: 'Действие выполнено',
    startMiners: 'Запустить майнеры',
    stopMiners: 'Остановить майнеры',
    restartMiners: 'Перезапустить майнеры',
    rebootMiners: 'Перезагрузить майнеры',
    updateFirmwareQuestion: 'Обновить прошивку?',
    // Users Page
    addNewUser: 'Добавить',
    noUsers: 'Нет пользователей',
    group: 'Группа',
    mail: 'Почта',
    active: 'Активен',
    notActive: 'Не активен',
    id: 'ID',
    deleteUser: 'Удалить пользователя',
    userDeleted: 'Пользователь удалён',
    ok: 'OK',
    clusterId: 'ID кластера',
    changeRole: 'Изменить роль',
    roleId: 'Роль',
    roleSuperAdmin: 'Суперадмин',
    roleAdmin: 'Админ',
    roleManager: 'Менеджер',
    roleUser: 'Пользователь',
    confirmRoleChange: 'Изменить роль пользователя на {role}?',
    roleUpdated: 'Роль пользователя обновлена',
    // Admin Settings
    adminSettings: 'Настройки',
    telegramBotSettings: 'Настройки Telegram бота',
    telegramBotUsername: 'Имя бота',
    telegramBotUsernameHint: "Имя без символа {'@'} (например MyBot)",
    telegramBotToken: 'Токен бота',
    telegramBotTokenHint: 'Токен от BotFather',
    testConnection: 'Проверить подключение',
    settingsSaved: 'Настройки сохранены',
    settingsSaveFailed: 'Ошибка сохранения настроек',
    telegramConnectionSuccess: 'Подключение успешно! Бот работает.',
    telegramConnectionFailed: 'Ошибка подключения. Проверьте токен.',
    botStatus: 'Статус бота',
    botName: 'Имя бота',
    botUsername: 'Username бота',
    // Clusters
    clusters: 'Кластеры',
    currentClusterId: 'Текущий ID кластера',
    searchClusters: 'Поиск кластеров',
    orderBy: 'Сортировать по',
    asc: 'По возрастанию',
    desc: 'По убыванию',
    addCluster: 'Добавить кластер',
    frontUrl: 'Front URL',
    clusterType: 'Тип кластера',
    actions: 'Действия',
    noClusters: 'Нет кластеров',
    clustersLoadFailed: 'Не удалось загрузить кластеры',
    deleteClusterConfirm: 'Удалить этот кластер?',
    clusterDeleted: 'Кластер удалён',
    clusterCreated: 'Кластер создан',
    clusterUpdated: 'Кластер обновлён',
    clusterSettings: 'Настройки кластера',
    confirmUrl: 'URL подтверждения',
    mailer: 'Почтовик',
    mailerService: 'Сервис',
    mailerServiceHint: 'Оставьте пустым для настройки через host',
    host: 'Хост',
    port: 'Порт',
    secureConnection: 'Безопасное соединение',
    mailerUser: 'Пользователь',
    mailerPassword: 'Пароль',
    mailerFrom: 'Отправитель',
    telegram: 'Telegram',
    telegramBot: 'Telegram бот',
    clusterSettingsSaved: 'Настройки кластера сохранены',
    newCluster: 'Новый кластер',
    createCluster: 'Создать кластер',
    editCluster: 'Редактировать кластер',
    accessDenied: 'Доступ запрещён',
    // Profile
    profileTitle: 'Профиль',
    newPasswordLabel: 'Новый пароль',
    confirmNewPassword: 'Подтвердите новый пароль',
    linkTelegramAccount: 'Привязать Telegram',
    unlinkTelegramAccount: 'Отвязать Telegram',
    telegramLinkTitle: 'Привязка Telegram',
    telegramLinkDescription: 'Перейдите по ссылке для привязки Telegram аккаунта:',
    copyLink: 'Копировать ссылку',
    downloadQRCode: 'Скачать QR-код',
    scanQRCode: 'Или отсканируйте QR-код:',
    qrCodeHint: 'Вы можете сфотографировать этот QR-код камерой телефона.',
    profileUpdated: 'Профиль успешно обновлён',
    profileUpdateFailed: 'Ошибка обновления профиля',
    passwordsDoNotMatch: 'Пароли не совпадают',
    telegramLinked: 'Telegram аккаунт успешно привязан',
    telegramUnlinked: 'Telegram аккаунт успешно отвязан',
    telegramLinkFailed: 'Ошибка создания ссылки Telegram',
    telegramUnlinkFailed: 'Ошибка отвязки Telegram аккаунта',
    noTelegramLinked: 'Telegram аккаунт не привязан',
    telegramNotConfigured: 'Telegram бот не настроен. Обратитесь к администратору.',
    confirmUnlink: 'Подтверждение отвязки',
    confirmUnlinkMessage: 'Вы уверены, что хотите отвязать Telegram аккаунт',
    unlink: 'Отвязать',
    linkCopied: 'Ссылка скопирована',
    phone: 'Телефон',
    telegramUsername: 'Telegram аккаунт',
    telegramUsernameHint: "Имя пользователя без символа {'@'} (например ivanov)",
    phoneHint: 'Номер телефона с кодом страны',
    // Messages
    pleaseWait: 'Пожалуйста, подождите...',
    invalidLink: 'Недействительная ссылка',
    confirmationFailed: 'Ошибка подтверждения. Попробуйте снова.',
    backToLogin: 'Вернуться к входу',
    emailSent: 'Письмо отправлено. Проверьте почту для подтверждения регистрации.',
    // Password Reset
    forgotPassword: 'Забыли пароль',
    forgotPasswordHint: 'Введите ваш email и мы отправим ссылку для сброса пароля.',
    sendResetLink: 'Отправить ссылку',
    resetLinkSent: 'Если аккаунт с таким email существует, мы отправили ссылку для сброса пароля.',
    resetPassword: 'Сбросить пароль',
    newPassword: 'Новый пароль',
    passwordMinLength: 'Пароль должен быть не менее 4 символов',
    passwordsMustMatch: 'Пароли должны совпадать',
    passwordResetSuccess: 'Ваш пароль успешно изменён. Теперь вы можете войти с новым паролем.',
    invalidResetLink: 'Недействительная или просроченная ссылка',
    tryAgain: 'Попробовать снова',
    connectionError: 'Не удалось подключиться к серверу',
    requestFailed: 'Ошибка запроса. Попробуйте снова.',
    resetFailed: 'Ошибка сброса пароля. Ссылка могла устареть.',
    // Settings
    alarmNotifications: 'Уведомления',
    telegramAlarms: 'Telegram',
    alarmsSentTo: 'Уведомления будут отправлены',
    telegramNotLinked: 'Telegram аккаунт не привязан',
    alarms: {
        new_device: 'Устройство добавлено',
        device_removed: 'Устройство удалено',
        device_online: 'Устройство в сети',
        device_offline: 'Устройство не в сети',
        device_pools_changed: 'Пулы устройства изменены',
        chip_temperature_gt: 'Температура чипа выше чем',
        board_temperature_gt: 'Температура платы выше чем',
        efficiency_lt: 'Эффективность ниже чем',
        power_consumption_gt: 'Потребление энергии выше чем',
        power_consumption_lt: 'Потребление энергии ниже чем',
    }
};
